import dayjs from 'dayjs'

export const isEndTimeAfterStartTime = (startTime: string, endTime: string) => {
  const start = dayjs(`2000-01-01T${startTime}`)
  const end = dayjs(`2000-01-01T${endTime}`)

  return end.isAfter(start)
}
